import React, { Component, Suspense } from 'react';
import 'bulma/css/bulma.css';
import './index.css';
import { Route, Routes } from 'react-router-dom';
import { Footer, NavigationBar, NotFound } from './components';
import { ProjectTemplate } from './pages';
import Home from './pages/Home';
import ScrollToTop from './ScrollToTop';

// const Products = withRouter(
//   lazy(() => import(/* webpackChunkName: "products" */ './products/Products')),
// );
// const Products = lazy(() =>
//   import(/* webpackChunkName: "products" */ './products/Products'),
// );

// const Discounts = lazy(() =>
//   import(/* webpackChunkName: "discounts" */ './Discounts'),
// );

class App extends Component {
  render() {
    return (
      <div className="flex flex-col min-h-screen bg-background">
        <NavigationBar />
        <div>
          <main className="py-5 layout border-vertical">
            <Suspense fallback={<div>Loading...</div>}>
              <ScrollToTop>
                <Routes>
                {/* <Redirect from="/" exact to="/home" /> */}
                <Route path="/" element={<Home />} />

                {/* Main Pages */}
                <Route path="/*" element={<Home />} />
                <Route path="*" element={<NotFound />} />
                
                {/* Project Pages */}
                <Route path="/project/:slug" element={<ProjectTemplate />}/>
                <Route path="/project/null" element={<NotFound />} />

                {/* Demos */}
                {/*
                <Route path="projects/*" element={<Projects />} />
                <Route path="contact/*" element={<Contact />} />
                */}
              </Routes>
              </ScrollToTop>
            </Suspense>
          </main>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;
